module.exports = function() {
  return new Worker(__webpack_public_path__ + "b1d19923d09e095e52b1.worker.js");
};